/* ===========================================================
   Card Swatches — Tubuai
   Al tocar un swatch:
   - Cambia la imagen de la card a la de la variante
   - Actualiza el href del link al producto (?variant=ID)
   - Marca el swatch como activo
   =========================================================== */

(function () {
  if (window.__cardSwatchesInit) return;
  window.__cardSwatchesInit = true;

  document.addEventListener('click', function (e) {
    const swatch = e.target.closest('.card-swatch');
    if (!swatch) return;
    e.preventDefault();

    const card = swatch.closest('.card-wrapper, .card, .grid__item');
    if (!card) return;

    const newImage = swatch.dataset.variantImage;
    const newUrl = swatch.dataset.variantUrl;

    // 1. Cambiar imagen de la card
    if (newImage) {
      // Selector tolerante: agarra el primer img dentro del card__media o .media
      const img = card.querySelector('.card__media img, .media img');
      if (img) {
        img.src = newImage;
        // Limpiamos srcset para evitar que el browser ignore el src nuevo
        img.removeAttribute('srcset');
        img.removeAttribute('data-srcset');
        // Disparamos un fade rápido para que el cambio se note
        img.style.transition = 'opacity 0.2s';
        img.style.opacity = '0.5';
        requestAnimationFrame(() => {
          img.style.opacity = '1';
        });
      }
    }

    // 2. Actualizar todos los links al producto dentro de la card
    if (newUrl) {
      card.querySelectorAll('a').forEach((a) => {
        if (a.href && a.href.indexOf('/products/') > -1) {
          a.href = newUrl;
        }
      });
    }

    // 3. Marcar swatch activo
    const group = swatch.closest('[data-card-swatches]');
    if (group) {
      group
        .querySelectorAll('.card-swatch')
        .forEach((s) => s.classList.remove('is-active'));
      swatch.classList.add('is-active');
    }
  });

  // Accesibilidad: hacer que Enter/Space activen el swatch (los <button> ya lo hacen,
  // pero esto previene el scroll default del Space)
  document.addEventListener('keydown', function (e) {
    if (e.key !== ' ') return;
    const swatch = e.target.closest('.card-swatch');
    if (swatch) e.preventDefault();
  });
})();
